import React, { useState, useEffect, useRef  } from "react";
import Subtract from "../images/Subtract.png";
import calculate from "../images/calculate2.png";
import calculateTwo from "../images/calculate2-img.png";
import PrimaryBtn from "../component/btn/PrimaryBtn";
import img_content01 from "../images/px-img01.jpg";
import img_content02 from "../images/px-img02.png";
import img_content03 from "../images/px-img03.png";
import img_content_map from "../images/px-img-map.png";
import img_content04 from "../images/px-img04.png";
import img_content05 from "../images/px-img05.png";
import img_content06 from "../images/px-img06.png";
import img_content from "../images/px-img15.png";
import img_content015 from "../images/px-img16.jpg";
// import TrackingHistory from "../component/tracking component/TrackingHistory";
import TrackingLogs from "../component/tracking component/TrackingLogs";
import { NavLink } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
import { Helmet } from "react-helmet";
export default function TrackingNew() {
  const [active, setActive] = useState("waybill");
  const words = ["On The Go", "Superfast", "Anytime", "Anywhere"];
  const [searchParams, setSearchParams] = useSearchParams();
  const [wordIndex, setWordIndex] = useState(0);
  const [charIndex, setCharIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);
  const typingSpeed = 80;
  const deletingSpeed = 40;
  const delayBetweenWords = 1500;

  useEffect(() => {
    const currentWord = words[wordIndex];

    let timeout;

    if (!isDeleting && charIndex < currentWord.length) {
      timeout = setTimeout(() => {
        setCharIndex(charIndex + 1);
      }, typingSpeed);
    } else if (isDeleting && charIndex > 0) {
      timeout = setTimeout(() => {
        setCharIndex(charIndex - 1);
      }, deletingSpeed);
    } else if (!isDeleting && charIndex === currentWord.length) {
      timeout = setTimeout(() => {
        setIsDeleting(true);
      }, delayBetweenWords);
    } else if (isDeleting && charIndex === 0) {
      setIsDeleting(false);
      setWordIndex((prev) => (prev + 1) % words.length);
    }

    return () => clearTimeout(timeout);
  }, [charIndex, isDeleting, wordIndex]);

  const [inputValue, setInputValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const handleTrack = async () => {
    if (!inputValue) {
      setError("Please enter value");
      return;
    }
    setHasScrolled(false);
    const params = Object.fromEntries(searchParams.entries());
    setLoading(true);
    setError("");
    setData(null);

    try {
      const formData = new URLSearchParams();

      if (active === "waybill") {
        formData.append("waybill_number", inputValue);
        setSearchParams({ waybill_no: inputValue });
      } else {
        formData.append("number", inputValue);
        setSearchParams({ mobile: inputValue });
      }

      const res = await fetch("https://v2-api-stage.parcelx.in/px-tracking-v2", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: formData,
      });

      const result = await res.json();

      if (!res.ok) {
        throw new Error(result.message || "Something went wrong");
      }

      setData(result);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };
  const fetchTracking = async (type, value) => {
    setLoading(true);
    setError("");
    setData(null);

    try {
      const formData = new URLSearchParams();

      if (type === "waybill") {
        formData.append("waybill_number", value);
      } else {
        formData.append("number", value);
      }

      const res = await fetch("https://v2-api-stage.parcelx.in/px-tracking-v2", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: formData,
      });

      const result = await res.json();

      if (!res.ok) {
        throw new Error(result.message || "Something went wrong");
      }

      setData(result);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    const waybillFromUrl = searchParams.get("waybill_no");

    if (waybillFromUrl) {
      setActive("waybill");
      setInputValue(waybillFromUrl);

      fetchTracking("waybill", waybillFromUrl);
    }

    setInitialLoading(false);
  }, []);
  const trackingRef = useRef(null);
    const [hasScrolled, setHasScrolled] = useState(false);
    useEffect(() => {

    if (data?.data?.length && !hasScrolled) {

        const element = trackingRef.current;

        if (element) {

            const y =
                element.getBoundingClientRect().top +
                window.pageYOffset -
                90;

            window.scrollTo({
                top: y,
                behavior: "smooth"
            });

            setHasScrolled(true);
        }
    }

}, [data, hasScrolled]);
  return (
    <div>
      <Helmet>
        <title>Parcelx - Tracking</title>
      </Helmet>
      <section className="section01">
        <div className="container-fluid">
          <div className="col-md-11 mx-auto">
            <div className="row align-items-center">
              <div className="col-md-4 order-md-2">
                <h2 className="heading tracking-heading">
                  {" "}
                  Track your parcels <br />
                  <span className="typing-text">
                    {words[wordIndex].substring(0, charIndex)}
                  </span>
                  <span className="cursor">|</span>
                </h2>
              </div>
              <div className="col-md-8">
                <div className="tracking-main-box">
                  <div className="track-btn-box">
                    <p className="subtitle mb-0">
                      Enter your Waybill or Mobile No. to track your package
                    </p>
                    <div className="track-items-box">
                      <button
                        className={`track-item ${active === "waybill" ? "active" : ""}`}
                        onClick={() => setActive("waybill")}
                      >
                        Waybill
                      </button>
                      <button
                        type="button"
                        className={`track-item ${active === "mobile" ? "active" : ""}`}
                        onClick={() => setActive("mobile")}
                      >
                        Mobile Number
                      </button>
                    </div>
                  </div>
                  <form
                    onSubmit={(e) => {
                      e.preventDefault();
                      handleTrack();
                    }}
                  >
                    <div className="input-btn mb-2">
                      <input
                        className="form-control"
                        value={inputValue}
                        onChange={(e) => {
                          let value = e.target.value;
                          value = value.replace(/\s+/g, ",");

                          value = value.replace(/,+/g, ",");
                          value = value.replace(/^,/, "");
                          setInputValue(value);
                          setError("");
                        }}
                        // onChange={(e) => setInputValue(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault();
                            handleTrack();
                          }
                        }}
                        placeholder={
                          active === "waybill"
                            ? "Enter your waybill no. (Separate multiple by comma)"
                            : "Enter your mobile number"
                        }
                      />
                      {/* <PrimaryBtn
                        text={
                          <>
                            {" "}
                            Track&nbsp;<span>Your</span>&nbsp;Order{" "}
                          </>
                        }
                        showIcon={false}
                        onClick={handleTrack}
                      /> */}
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={handleTrack}
                      >
                        Track&nbsp;<span>Your</span>&nbsp;Order
                      </button>
                    </div>
                    {loading && <p>Loading...</p>}
                    {error && <p style={{ color: "red" }}>{error}</p>}
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {initialLoading || loading ? (
        <div className="tracking-loader text-center py-5">
          <p>Fetching tracking details...</p>
        </div>
      ) : data ? (
        <div className="tracking-deatils" ref={trackingRef}>
          {data?.data?.map((shipment, index) => (
            <TrackingLogs key={index} data={{ data: [shipment] }} />
          ))}
        </div>
      ) : (
        <div className="tracking-start">
          <section className="section-02">
            <div className="container-fluid">
              <div className="col-md-11 mx-auto">
                <div className="img-content-box">
                  <div className="row align-items-center">
                    <div className="col-md-4">
                      <img src={img_content01} className="img-fluid" />
                    </div>
                    <div className="col-md-8">
                      <h4>
                        <span>Do you have a business? </span> We can simplify
                        your shipping
                      </h4>
                      <p>
                        Whether you are a small business, a large enterprise, or
                        an online seller looking to scale, ParcelX makes
                        shipping simple, reliable, and cost-effective, so you
                        can focus on growing your business.
                      </p>
                      <div className="shipping-boxs">
                        <div className="shipping-box-items">
                          Shipping Starts from Rs. 21/500gm*
                        </div>
                        <div className="shipping-box-items">
                          20+ Courier Partners
                        </div>
                        <div className="shipping-box-items">
                          Improved Communication with users
                        </div>
                        <div className="shipping-box-items">
                          Same Day/ Next Day Deliveries
                        </div>
                        <div className="shipping-box-items">
                          95%+ Successful Deliveries
                        </div>
                        <div className="shipping-box-items">
                          Analytics that actually solves the issue
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="section-02">
            <div className="container-fluid">
              <div className="col-md-11 mx-auto">
                <div className="row">
                  <div className="col-md-8 mb-3">
                    <div className="img-content-box map-box">
                      <div className="row">
                        <div className="col-md-6 order-md-2">
                          <img
                            src={img_content02}
                            className="img-fluid right-img"
                          />
                        </div>
                        <div className="col-md-6">
                          <div className="map-box-content">
                            <div className="shipping-box-items d-inline-block mb-3">
                              Solution for all kinds of businesses
                            </div>
                            <h4 className="mb-3">
                              <b>B2B Shipping:</b> Full Truck Load & Part Truck
                              Load
                            </h4>
                            <p className="mb-0">
                              Efficient Full Truck Load (FTL) & (PTL) solutions
                              designed to move your bulk shipments reliably and
                              cost-effectively.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 mb-3">
                    <div className="img-content-box">
                      <img src={img_content03} className="img-fluid" />
                      <h4 className="fw-600">ParcelX PaceX</h4>
                      <p>
                        Superfast Same Day and Next Day delivery solutions built
                        for businesses that value speed, reliability, and
                        customer satisfaction.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="section-02">
            <div className="container-fluid">
              <div className="col-md-11 mx-auto">
                <div className="row">
                  <div className="col-md-4 mb-3">
                    <div className="img-content-box text-start map-box position-relative">
                      <img
                        src={img_content_map}
                        className="img-fluid track-mape-img"
                      />
                      <img
                        src={img_content015}
                        className="img-fluid mb-4 z-index mt-3 ms-3 border-r-8"
                      />
                      <img
                        src={img_content}
                        className="img-fluid right-image tracking-img mt-0"
                      />
                      <div className="map-box-content">
                        <h4 className="fw-600">ParcelX Videsh</h4>
                        <p className="mb-0">
                          Seamless international shipping to 220+ countries,
                          offering best rates, fast delivery, tracking for your
                          global shipments.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-8 mb-3">
                    <div className="img-content-box map-box">
                      <div className="row align-items-end">
                        <div className="col-md-6 order-md-2">
                          <img
                            src={img_content04}
                            className="img-fluid right-img"
                          />
                        </div>
                        <div className="col-md-6">
                          <div className="map-box-content">
                            <div className="shipping-box-items d-inline-block mb-3">
                              Making interactions with customers easy
                            </div>
                            <h4 className="mb-3">
                              <b>Communication Module:</b> Interact, send
                              updates & many more...
                            </h4>
                            <p className="mb-0">
                              Connect with your audience like never before with
                              Px Conect! Send SMS, Emails, WhatsApp & IVR calls
                              at unbeatable rates.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="section-02">
            <div className="container-fluid">
              <div className="col-md-11 mx-auto position-relative tracking-img-section">
                <img
                  src={img_content05}
                  className="img-fluid left-image d-md-block d-none"
                />
                <img
                  src={img_content06}
                  className="img-fluid right-image d-md-block d-none"
                />
                <div className="row">
                  <div className="col-lg-9 col-md-6 mx-auto">
                    <div className="text-center">
                      <h2 className="heading">
                        The Easiest way of Ecommerce Shipping
                      </h2>
                      <p>
                        ParcelX simplifies shipping with India’s smartest
                        AI-powered platform. Manage end-to-end shipping
                        seamlessly, access multiple carriers in one place, and
                        save time and costs effortlessly.
                      </p>
                      <a
                        href="https://seller.parcelx.in/register"
                        className="btn btn-secondary"
                      >
                        Get Started for Free{" "}
                        <i className="fas fa-long-arrow-right"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="eccomerce-img-box">
                <div className="row m-0">
                  <div className="col-md-4 mb-3"></div>
                  <div className="col-md-4 text-center mb-3"></div>
                  <div className="col-md-4 mb-3 text-end"></div>
                </div>
              </div>
            </div>
          </section>
        </div>
      )}
    </div>
  );
}
